export type PaymentMethodId = "money" | "credit_card" | "google_pay";

/** Payment methods persisted on the store (GraphQL / DB). */
export type StorablePaymentMethodId = Extract<PaymentMethodId, "money" | "credit_card">;

export const STORABLE_PAYMENT_METHOD_IDS = ["money", "credit_card"] as const satisfies readonly StorablePaymentMethodId[];

export function isStorablePaymentMethodId(value: string): value is StorablePaymentMethodId {
  return value === "money" || value === "credit_card";
}

export interface PaymentMethodStrategy {
  readonly id: PaymentMethodId;
  readonly label: string;
  formatForWhatsApp(): string;
  isAvailable(): boolean;
}
